import React from "react"

import "./container.css"

const Container = ({ children }) => {
  return <div className="container-main">{children}</div>
}

export { Container }
